import { SelectionState, EditorState, genKey, ContentBlock } from 'draft-js'
import { OrderedMap } from 'immutable'

/**
 * Creates a new line after the control key block
 * @param {EditorState} editorState
 * @param {string} controlKey
 * @returns {EditorState}
 */
function createNewLineAfterBlock(editorState, controlKey){
  var content = editorState.getCurrentContent()
  var blockMap = content.getBlockMap()
  var contentBlocks = blockMap.toArray()

  var index = contentBlocks.findIndex(block => block.get('key') == controlKey)
  var newKey = genKey()
  var newContentBlock = new ContentBlock({
    key: newKey,
    type: 'unstyled',
    text: ' ',
  })
  var part1 = blockMap.slice(0, (index + 1))
  var part2 = part1.concat( new OrderedMap({[newKey]: newContentBlock}) )
  var part3 = blockMap.slice(index + 1)

  var newBlockMap = part2.concat(part3)
  content = content.merge({blockMap: newBlockMap});

  editorState = EditorState.push(editorState, content, 'insert-fragment')
  // This selection stuff seems to have no affect
  var newSelection = SelectionState.createEmpty(controlKey)
  newSelection = newSelection.merge({
    hasFocus: true,
  });
  return EditorState.forceSelection(editorState, newSelection)

}

export default createNewLineAfterBlock


// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/createNewLineAfterBlock.js